export default __webpack_public_path__ + "static/media/jihyo2.2e2a8659.jpg";